(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-product"]) return;
  try {
    
  const productSection = document.querySelector('[id^="ProductInfo-"]');
  const stickyData = productSection.dataset.sticky;
  if (stickyData === 'true') {
    var sidebarEl = document.querySelector('.sidebar__inner');
    var sidebar = new StickySidebar(sidebarEl, {
      topSpacing: 40,
      containerSelector: '.product__info-wrapper',
      innerWrapperSelector: '.sidebar__inner-padding',
      resizeSensor: true,
      minWidth: 992,
    });
    sidebarEl.addEventListener('affix.bottom.stickySidebar', function (event) {
      console.log('Sidebar has stuck bottom of viewport.');
    });
  }
  console.log('stickyData', stickyData);
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
      if (stickyData === 'true') {
        sidebar.updateSticky();
      }
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class AccountModal extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');

      this.detailsContainer.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summaryToggle.addEventListener(
        'click',
        this.onSummaryClick.bind(this)
      );

      this.summaryToggle.setAttribute('role', 'button');
    }

    isOpen() {
      return this.detailsContainer.hasAttribute('open');
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open(event);
    }

    onBodyClick(event) {
      if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
    }

    open(event) {
      this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this);
      event.target.closest('details').setAttribute('open', true);
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');

      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }

    close(focusToggle = true) {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
    }
  }

  customElements.define('account-modal', AccountModal);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner-v2"] && !Shopify.designMode) return;
  try {
    
  function updateCountdown() {
    const timerElement = document.querySelector('.countdown-timer');
    if (!timerElement) return;

    // Parse the target date and treat it as MST (UTC-7)
    const dateString = timerElement.dataset.targetDate;
    const MST_OFFSET = -7; // MST is UTC-7

    // Parse date string (format: YYYY-MM-DD HH:MM:SS)
    const [datePart, timePart] = dateString.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);

    // Create date in UTC, then adjust for MST offset
    const targetDate = Date.UTC(year, month - 1, day, hours - MST_OFFSET, minutes, seconds);

    function update() {
      const now = Date.now();
      const distance = targetDate - now;

      if (distance <= 0) {
        document.getElementById('hours').textContent = '00';
        document.getElementById('minutes').textContent = '00';
        document.getElementById('seconds').textContent = '00';
        clearInterval(timerInterval);
        return;
      }

      const totalHours = Math.floor(distance / (1000 * 60 * 60));
      const mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((distance % (1000 * 60)) / 1000);

      document.getElementById('hours').textContent = String(totalHours).padStart(2, '0');
      document.getElementById('minutes').textContent = String(mins).padStart(2, '0');
      document.getElementById('seconds').textContent = String(secs).padStart(2, '0');
    }

    update();
    const timerInterval = setInterval(update, 1000);
  }

  updateCountdown();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  function updateCountdown() {
    const timerElement = document.querySelector('.countdown-timer');
    if (!timerElement) return;
    
    // Parse the target date and treat it as MST (UTC-7)
    const dateString = timerElement.dataset.targetDate;
    const MST_OFFSET = -7; // MST is UTC-7
    
    // Parse date string (format: YYYY-MM-DD HH:MM:SS)
    const [datePart, timePart] = dateString.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    
    // Create date in UTC, then adjust for MST offset
    const targetDate = Date.UTC(year, month - 1, day, hours - MST_OFFSET, minutes, seconds);
    
    function update() {
      const now = Date.now();
      const distance = targetDate - now;
      
      if (distance <= 0) {
        document.getElementById('hours').textContent = '00';
        document.getElementById('minutes').textContent = '00';
        document.getElementById('seconds').textContent = '00';
        clearInterval(timerInterval);
        return;
      }

      const totalHours = Math.floor(distance / (1000 * 60 * 60));
      const mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((distance % (1000 * 60)) / 1000);
      
      document.getElementById('hours').textContent = String(totalHours).padStart(2, '0');
      document.getElementById('minutes').textContent = String(mins).padStart(2, '0');
      document.getElementById('seconds').textContent = String(secs).padStart(2, '0');
    }
    
    update();
    const timerInterval = setInterval(update, 1000);
  }

  updateCountdown();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-2024"]) return;
  try {
    
  const productSection = document.querySelector('[id^="ProductInfo-"]');
  const stickyData = productSection.dataset.sticky;
  if (stickyData === 'true') {
    var sidebarEl = document.querySelector('.sidebar__inner');
    var sidebar = new StickySidebar(sidebarEl, {
      topSpacing: 40,
      containerSelector: '.product__info-wrapper',
      innerWrapperSelector: '.sidebar__inner-padding',
      resizeSensor: true,
      minWidth: 992,
    });
    sidebarEl.addEventListener('affix.bottom.stickySidebar', function (event) {
      console.log('Sidebar has stuck bottom of viewport.');
    });
  }
  console.log('stickyData', stickyData);
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
      if (stickyData === 'true') {
        sidebar.updateSticky();
      }
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-2025"]) return;
  try {
    
  const productSection = document.querySelector('[id^="ProductInfo-"]');
  const stickyData = productSection.dataset.sticky;
  if (stickyData === 'true') {
    var sidebarEl = document.querySelector('.sidebar__inner');
    var sidebar = new StickySidebar(sidebarEl, {
      topSpacing: 40,
      containerSelector: '.product__info-wrapper',
      innerWrapperSelector: '.sidebar__inner-padding',
      resizeSensor: true,
      minWidth: 992,
    });
    sidebarEl.addEventListener('affix.bottom.stickySidebar', function (event) {
      console.log('Sidebar has stuck bottom of viewport.');
    });
  }
  console.log('stickyData', stickyData);
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
      if (stickyData === 'true') {
        sidebar.updateSticky();
      }
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const productSection = document.querySelector('[id^="ProductInfo-"]');
  const stickyData = productSection.dataset.sticky;
  if (stickyData === 'true') {
    var sidebarEl = document.querySelector('.sidebar__inner');
    var sidebar = new StickySidebar(sidebarEl, {
      topSpacing: 40,
      containerSelector: '.product__info-wrapper',
      innerWrapperSelector: '.sidebar__inner-padding',
      resizeSensor: true,
      minWidth: 992,
    });
    sidebarEl.addEventListener('affix.bottom.stickySidebar', function (event) {
      console.log('Sidebar has stuck bottom of viewport.');
    });
  }
  console.log('stickyData', stickyData);
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
      if (stickyData === 'true') {
        sidebar.updateSticky();
      }
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pairs-well-with"] && !Shopify.designMode) return;
  try {
    
  class PairsWellWith extends HTMLElement {
    constructor() {
      super();
      this.sectionElement = this;
      this.init();
    }

    init() {
      // Initialize components directly since products are already loaded via metafield
      this.initColorSwatches();
      this.initMobileSlider();
      this.initYotpo();
      this.syncDotsWithPages();
    }

    syncDotsWithPages() {
      const sliderComponent = this.sectionElement.querySelector('slider-component');
      if (!sliderComponent) return;

      const dotLinks = this.sectionElement.querySelectorAll('.slider-counter__link[data-slide-index]');
      if (!dotLinks.length) return;

      // Function to sync dots visibility with calculated pages
      const syncDots = () => {
        // Wait a bit for slider to calculate pages
        setTimeout(() => {
          if (sliderComponent.totalPages) {
            dotLinks.forEach((dot, index) => {
              // Show dots up to totalPages, hide the rest
              if (index < sliderComponent.totalPages) {
                dot.style.display = '';
              } else {
                dot.style.display = 'none';
              }
            });
          }
        }, 50);
      };

      // Try immediately and after delays to ensure slider is initialized
      syncDots();
      setTimeout(syncDots, 100);
      setTimeout(syncDots, 300);

      // Listen for resize events (which trigger initPages)
      const resizeObserver = new ResizeObserver(() => {
        syncDots();
      });
      if (sliderComponent.slider) {
        resizeObserver.observe(sliderComponent.slider);
      }

      // Listen for slideChanged events to ensure dots are synced
      sliderComponent.addEventListener('slideChanged', syncDots);
    }

    initColorSwatches() {
      const section = this.sectionElement;
      const colorSwatches = section.querySelectorAll('.pairs-well-with .product-colors-wrap .color-swatch');

      colorSwatches.forEach((swatch) => {
        swatch.addEventListener('click', function (e) {
          e.preventDefault();

          const swatchContainer = e.target.closest('.product-colors-wrap');
          const cardWrapper = e.target.closest('.pairs-well-with-card, .card-wrapper');

          if (!swatchContainer || !cardWrapper) return;

          swatchContainer.querySelectorAll('.color-swatch').forEach((swatchImg) => {
            swatchImg.classList.remove('active');
          });
          swatch.classList.add('active');

          const cardMainImg = cardWrapper.querySelector('.card-mainimg, .pairs-well-with-card__image');
          if (cardMainImg) {
            cardMainImg.style.display = 'none';
          }

          cardWrapper.querySelectorAll('.grid-product__color-image').forEach((swatchBGImg) => {
            swatchBGImg.classList.remove('is-active');
          });

          const variantId = swatch.dataset.variantId;
          const variantImage = swatch.dataset.variantImage;
          const variantUrl = swatch.href;
          const priceOriginal = swatch.dataset.price;
          const priceSaleOn = swatch.dataset.compareprice;

          if (variantId) {
            const variantImageEl = cardWrapper.querySelector('.grid-product__color-image--' + variantId);
            if (variantImageEl && variantImage) {
              const imgElement = '<a href="' + variantUrl + '"><img src="' + variantImage + '" loading="lazy" /></a>';
              variantImageEl.innerHTML = imgElement;
              variantImageEl.classList.add('is-active');
            }

            const priceElement = cardWrapper.querySelector('.pairs-well-with-card__price, .price');
            if (priceElement && priceOriginal) {
              if (priceSaleOn) {
                const salePriceEl = priceElement.querySelector('.price-item--sale.price-item--last');
                const regularPriceEl = priceElement.querySelector('.price__sale .price-item.price-item--regular');
                if (salePriceEl) salePriceEl.innerHTML = priceOriginal;
                if (regularPriceEl) regularPriceEl.innerHTML = priceSaleOn;
                priceElement.classList.add('price--on-sale');
              } else {
                const regularPriceEl = priceElement.querySelector(
                  '.price-item.price-item--regular, .price-item--regular'
                );
                if (regularPriceEl) regularPriceEl.innerHTML = priceOriginal;
                priceElement.classList.remove('price--on-sale');
              }
            }

            const variantInput = cardWrapper.querySelector('.pairs-well-with-variant-id, .product-variant-id');
            if (variantInput) {
              variantInput.value = variantId;
            }

            // Update button availability by fetching variant data
            const addButton = cardWrapper.querySelector('.pairs-well-with-card__add-button');
            if (addButton) {
              // Extract product handle from variant URL
              const urlParts = variantUrl.split('/products/');
              if (urlParts.length > 1) {
                const productHandle = urlParts[1].split('?')[0].split('#')[0];

                // Fetch product data to check variant availability
                fetch(`/products/${productHandle}.js`)
                  .then((response) => response.json())
                  .then((productData) => {
                    const variant = productData.variants.find((v) => v.id == variantId);
                    const buttonText = addButton.querySelector('span');

                    if (variant) {
                      if (!variant.available) {
                        addButton.setAttribute('disabled', 'disabled');
                        if (buttonText) {
                          buttonText.textContent = 'Sold out';
                        }
                      } else {
                        addButton.removeAttribute('disabled');
                        if (buttonText) {
                          buttonText.textContent = 'Add';
                        }
                      }
                    }
                  })
                  .catch((error) => {
                    console.error('Error fetching variant availability:', error);
                    // On error, keep button enabled and let form handle validation
                    addButton.removeAttribute('disabled');
                  });
              } else {
                // Fallback: keep button enabled if we can't parse URL
                addButton.removeAttribute('disabled');
              }
            }

            const lifestyleUrl = cardWrapper.querySelector('.life-style-content a');
            if (lifestyleUrl) {
              lifestyleUrl.href = variantUrl;
            }
          }
        });
      });

      const colorGrids = section.querySelectorAll('.pairs-well-with .grid-product__colors');
      colorGrids.forEach((grid) => {
        if (grid.firstElementChild) {
          grid.firstElementChild.click();
        }

        // Initialize Flickity if there are more than 3 color swatches
        const swatches = grid.querySelectorAll('.color-swatch');
        if (swatches.length > 3) {
          // Wait for Flickity to be available
          const initFlickity = () => {
            if (typeof Flickity !== 'undefined') {
              // Check if Flickity is already initialized on this element
              if (!grid.flickityInstance) {
                try {
                  grid.flickityInstance = new Flickity(grid, {
                    pageDots: true,
                    prevNextButtons: false,
                    freeScroll: true,
                    contain: true,
                    groupCells: true,
                    cellAlign: 'left',
                  });
                } catch (error) {
                  console.error('Error initializing Flickity for color swatches:', error);
                }
              }
            } else {
              // Retry after a short delay if Flickity isn't loaded yet
              setTimeout(initFlickity, 100);
            }
          };
          initFlickity();
        }
      });
    }

    initMobileSlider() {
      // Scroll to specified slide on mobile page load
      if (window.innerWidth < 750) {
        const section = this.sectionElement;
        const slider = section.querySelector('[id^="Slider-"]');
        const sliderComponent = section.querySelector('slider-component');

        // Get initial slide from data attribute (1-based index, default to 1)
        const initialSlideIndex = parseInt(section.dataset.initialSlideMobile || '1', 10);

        if (slider && sliderComponent && initialSlideIndex > 1) {
          // Wait for slider to be fully initialized and DOM to be ready
          const scrollToInitialSlide = () => {
            const slides = slider.querySelectorAll('[id^="Slide-"]');
            const targetSlideIndex = Math.min(initialSlideIndex - 1, slides.length - 1); // Convert to 0-based index

            if (slides.length >= initialSlideIndex && targetSlideIndex >= 0) {
              const targetSlide = slides[targetSlideIndex];

              if (targetSlide) {
                let scrollPosition = 0;

                if (sliderComponent.sliderItemOffset) {
                  // Use slider's calculated offset
                  scrollPosition = sliderComponent.sliderItemOffset * targetSlideIndex;
                } else {
                  // Fallback: calculate offset manually
                  const firstSlide = slides[0];
                  if (firstSlide) {
                    scrollPosition = targetSlide.offsetLeft - firstSlide.offsetLeft;
                  }
                }

                slider.scrollTo({
                  left: scrollPosition,
                  behavior: 'auto',
                });

                // Update the counter after scroll
                setTimeout(() => {
                  if (sliderComponent.update) {
                    sliderComponent.update();
                  }
                }, 50);
              }
            }
          };

          // Try immediately, then with delays to ensure slider is ready
          scrollToInitialSlide();
          setTimeout(scrollToInitialSlide, 100);
          setTimeout(scrollToInitialSlide, 300);
        }
      }
    }

    initYotpo() {
      if (window.yotpo && window.yotpo.initWidgets) {
        window.yotpo.initWidgets();
      }
    }
  }

  customElements.define('pairs-well-with', PairsWellWith);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            document.querySelectorAll('.product-colors-wrap .color-swatch').forEach(swatch => {
          swatch.addEventListener('click', function(e) {
            e.preventDefault();
            
            e.target.closest('.product-colors-wrap').querySelectorAll('.color-swatch').forEach(swatchImg =>{
              swatchImg.classList.remove('active');
            });
            swatch.classList.add('active');
      
            e.target.closest('.card-wrapper').querySelector('.card-mainimg').style.display = 'none';
            e.target.closest('.card-wrapper').querySelectorAll('.grid-product__color-image').forEach(swatchBGImg => {
              swatchBGImg.classList.remove('is-active');
            });
            
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            var variant_url = swatch.href;
            var price_original = swatch.dataset.price;
            var price_sale_on = swatch.dataset.compareprice;
            var img_Element = "<a href="+variant_url+"><img src="+image+" loading='lazy' /></a>";
            var el = document.querySelector('.grid-product__color-image--' + id);
            var lifestyleurl = e.target.closest('.card-wrapper').querySelector('.life-style-content');
            var parentCard = swatch.closest('.card-wrapper')
      el.innerHTML = img_Element;
      el.classList.add('is-active');
      if(price_sale_on){
        parentCard.querySelector('.price-item--sale.price-item--last').innerHTML = price_original;
        parentCard.querySelector('.price__sale .price-item.price-item--regular').innerHTML = price_sale_on;
        if (!parentCard.querySelector('.price').classList.contains('price--on-sale')) {
            parentCard.querySelector('.price').classList.add('price--on-sale');
        }
    }
    else{
        if (parentCard.querySelector('.price').classList.contains('price--on-sale')) {
            parentCard.querySelector('.price').classList.remove('price--on-sale')
        }
        parentCard.querySelector('.price-item.price-item--regular').innerHTML = price_original;
    }
      if(lifestyleurl){
        lifestyleurl.querySelector('a').href = variant_url
      }
          });
        });
        document.querySelectorAll('.grid-product__colors').forEach(grid =>{grid.firstElementChild.click()});
      document.querySelectorAll('.product-recommendations .grid-product__colors').forEach(grid =>{
        var flkty = new Flickity( grid, {
        pageDots: true,
        prevNextButtons: false,
        freeScroll: true,
        contain: true,
        groupCells: true,
        cellAlign: "left"
        });
      });   
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tease-crush2026"] && !Shopify.designMode) return;
  try {
    
  function updateCountdown() {
    const timerElement = document.querySelector('.countdown-timer');
    if (!timerElement) return;
    
    // Parse the target date and treat it as MST (UTC-7)
    const dateString = timerElement.dataset.targetDate;
    const MST_OFFSET = -7; // MST is UTC-7
    
    // Parse date string (format: YYYY-MM-DD HH:MM:SS)
    const [datePart, timePart] = dateString.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    
    // Create date in UTC, then adjust for MST offset
    const targetDate = Date.UTC(year, month - 1, day, hours - MST_OFFSET, minutes, seconds);
    
    function update() {
      const now = Date.now();
      const distance = targetDate - now;
      
      if (distance <= 0) {
        document.getElementById('hours').textContent = '00';
        document.getElementById('minutes').textContent = '00';
        document.getElementById('seconds').textContent = '00';
        clearInterval(timerInterval);
        return;
      }

      const totalHours = Math.floor(distance / (1000 * 60 * 60));
      const mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((distance % (1000 * 60)) / 1000);
      
      document.getElementById('hours').textContent = String(totalHours).padStart(2, '0');
      document.getElementById('minutes').textContent = String(mins).padStart(2, '0');
      document.getElementById('seconds').textContent = String(secs).padStart(2, '0');
    }
    
    update();
    const timerInterval = setInterval(update, 1000);
  }

  updateCountdown();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-column-media"] && !Shopify.designMode) return;
  try {
    
  function updateCountdown() {
    const timerElement = document.querySelector('.countdown-timer');
    if (!timerElement) return;
    
    // Parse the target date and treat it as MST (UTC-7)
    const dateString = timerElement.dataset.targetDate;
    const MST_OFFSET = -7; // MST is UTC-7
    
    // Parse date string (format: YYYY-MM-DD HH:MM:SS)
    const [datePart, timePart] = dateString.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    
    // Create date in UTC, then adjust for MST offset
    const targetDate = Date.UTC(year, month - 1, day, hours - MST_OFFSET, minutes, seconds);
    
    function update() {
      const now = Date.now();
      const distance = targetDate - now;
      
      if (distance <= 0) {
        document.getElementById('days').textContent = '00';
        document.getElementById('hours').textContent = '00';
        document.getElementById('minutes').textContent = '00';
        document.getElementById('seconds').textContent = '00';
        clearInterval(timerInterval);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((distance % (1000 * 60)) / 1000);
      
      document.getElementById('days').textContent = String(days).padStart(2, '0');
      document.getElementById('hours').textContent = String(hours).padStart(2, '0');
      document.getElementById('minutes').textContent = String(mins).padStart(2, '0');
      document.getElementById('seconds').textContent = String(secs).padStart(2, '0');
    }
    
    update();
    const timerInterval = setInterval(update, 1000);
  }

  updateCountdown();

  } catch(e) { console.error(e); }
})();
})();
